import { Dialog, DialogBackdrop, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel, TransitionChild } from '@headlessui/react';
import { BuildingStorefrontIcon, CalendarDaysIcon, Cog6ToothIcon, MegaphoneIcon, SparklesIcon, TagIcon, UserGroupIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import { userState } from "../../redux/reducers/userReducer";


import { classNames, onContactClick } from "../../helpers";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import menu_home from "../../assets/menu_home.svg";
import menu_schedule from "../../assets/menu_schedule.svg";
import menu_event from "../../assets/menu_event.svg";
import menu_setting from "../../assets/menu_setting.svg";
import menu_location from "../../assets/menu_location.svg";
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import BZLogo from "../BZLogo";
import { LayoutDashboardIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import MenuEventIcon from '../../assets/icons/MenuEventIcon';
import LogoutIcon from '../../assets/icons/LogoutIcon';
import WhatsAppIcon from '../../assets/icons/WhatsAppIcon';

export default function TwSidebar(props) {
  const {
    children,
    sidebarOpen,
    setSidebarOpen,
    logout,
  } = props
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const navigate = useNavigate();

  return (
    <div>
      <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"
        />

        <div className="fixed inset-0 flex">
          <DialogPanel
            transition
            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full bg-white"
          >
            <TransitionChild>
              <div className="absolute top-0 left-full flex w-16 justify-center pt-5 duration-300 ease-in-out data-closed:opacity-0">
                <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                  <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                  <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                </button>
              </div>
            </TransitionChild>
            {/* Sidebar component, swap this element with another sidebar if you like */}
            <TwSidebarMenue
              {...props}
            />
          </DialogPanel>
        </div>
      </Dialog>

      {/* Static sidebar for desktop */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-40 lg:flex lg:w-64 lg:flex-col">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <TwSidebarMenue
          {...props}
        />
      </div>
    </div>

  );
}


export function TwSidebarMenue({
  children,
  sidebarOpen,
  setSidebarOpen,
  logout,
  onAIAssistantToggle,
}) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const navigate = useNavigate();
  const [menuList, setMenuList] = React.useState([]);
  const [settingMenuList, setSettingMenuList] = React.useState([]);

  const eventList = [
    {
      id: 2,
      // label: "My Schedule",
      // label: "My Events",
      label: "pageTitle.myEvents",
      // icon: CalendarDaysIcon,
      // img: menu_event,
      icon: MenuEventIcon,
      navigate: { to: "/myschedule", state: { title: "Schedule List" } },
      current: false,
    },
    {
      id: 2,
      // label: "My Schedule",
      // label: "My Events",
      label: "pageTitle.mySellers",
      // icon: CalendarDaysIcon,
      // img: menu_event,
      icon: BuildingStorefrontIcon,
      navigate: { to: "/mysellers", state: { title: "Sellers List" } },
      current: false,
    },
    {
      id: 3,
      // label: "My Schedule",
      // label: "My Events",
      label: "pageTitle.myGuest",
      // icon: CalendarDaysIcon,
      // img: menu_event,
      icon: UserGroupIcon,
      navigate: { to: "/myguests", state: { title: "Guests List" } },
      current: false,
    },
    {
      id: 4,
      label: "pageTitle.myPromotions",
      icon: MegaphoneIcon,
      navigate: { to: "/mypromotions", state: { title: "My Promotions" } },
      current: false,
    },
    {
      // Catalogue plus its on-site sales, as tabs within one page.
      id: 5,
      label: "pageTitle.myProducts",
      icon: TagIcon,
      navigate: { to: "/products", state: { title: "My Products" } },
      current: false,
    },
  ];
  const settingList = [
    {
      // label: "Account Settings",
      id: "accountSettings",
      label: "pageTitle.accountSettings",
      icon: Cog6ToothIcon,
      navigate: { to: "/my-account" },
      current: false,
    },
    //     }
  ];
  const list = [
    {
      // label: 'Dashboard',
      label: 'pageTitle.dashboard',
      navigate: { to: "/home/dashboard", state: null },
      icon: LayoutDashboardIcon,
      // icon: menu_home,
      // img: menu_home,
      current: true
    },
    ...settingList,
  ];

  React.useEffect(() => {
    /* if ((userToken === undefined || userToken == "")) {
      // navigate("/home/dashboard");
      window.location.href = "/";
    } */
    let addmenu = [];
    if (userReduxState.businessType === "event") {
      addmenu = eventList;
    }
    let finelMenu = [...list]
    let i = 1;
    addmenu.length && addmenu.map((data) => {
      finelMenu.splice(i++, 0, data)
      return data;
    });
    delete finelMenu[0]; // comment if display Dashboard
    setMenuList(finelMenu.map((e) => ({ ...e, current: (e?.navigate?.to && window.location.pathname === e.navigate.to) ? true : false })));

    // setSettingMenuList(finelSettingList.map((e) => ({ ...e, current: (e?.navigate?.to && window.location.pathname === e.navigate.to) ? true : false })))
  }, []);


  const mainMenuClick = (item) => {
    if (item.subMenu) {
      /** no click **/
    } else if (item.navigate) {
      document.body.style.overflowY = ''
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      if (location.pathname !== item.navigate.to) {
        if (item.navigate.to === "/home/dashboard") {
          dispatch(dashboardActions.setCalendarSessionId(-1));
        } else if (item.navigate?.target && item.navigate.target === "newwindows") {
          window.open(item.navigate.to);
          return;
        }
        navigate(item.navigate.to, { state: item.navigate.state, ...item.navigate });
      }
    } else if (item.label.toLowerCase() === "logout") {
      return logout();
    }
  };

  const settingMenuClick = (item) => {
    if (item.id === "logout") {
      return logout();
    }
    navigate(item.navigate.to, {
      state: item.navigate.state,
    });
  };

  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto [bg-primary] border-r [border-gray-200] bg-form [px-6] pb-4">
      <div className="[visible sm:invisible] h-16 bg-white flex py-4 px-2 shrink-0 items-center justify-center border-b border-gray-200">
        <BZLogo className="visible sm:invisible" />
      </div>
      <nav className="flex flex-1 flex-col mx-6">
        <ul className="flex flex-1 flex-col gap-y-5">
          <li className="mt-[20%]">
            <ul className="-mx-2 space-y-1">
              {menuList.map((item) => (
                <li key={item.label}>
                  {!item.subMenu ? (<button
                    type="button"
                    onClick={() => { mainMenuClick(item) }}
                    className={classNames(
                      item.current
                        ? 'bg-secondary text-white [text-light-primary]'
                        : 'text-secondary hover:bg-secondary hover:text-white',
                      'group w-full flex items-center gap-x-4 rounded-xl p-2 py-3 text-lg 1sm:text-base font-semibold',
                    )}
                  >
                    {item.icon && (<item.icon
                      aria-hidden="true"
                      className={classNames(
                        item.current ? 'text-white' : 'text-secondary group-hover:text-white',
                        'size-6 shrink-0',
                      )}
                    />)}
                    {item.img && (<img
                      alt=""
                      src={item.img}
                      className={classNames(
                        item.current ? 'text-white' : 'text-secondary group-hover:text-white',
                        'size-6 shrink-0',
                      )}
                    />)}
                    {/* {item.label} */}
                    <span className="truncate">{t(item.label)}</span>
                  </button>) : (
                    <Disclosure as="div">
                      <DisclosureButton
                        className={classNames(
                          item.current
                            ? 'bg-light-primary text-white'
                            : 'text-gray-200 hover:bg-light-primary hover:text-white',
                          'group flex w-full items-center gap-x-4 rounded-xl p-2 py-3 text-left text-lg 1sm:text-base font-semibold',
                        )}
                      >
                        {/* <item.icon aria-hidden="true" className="size-6 shrink-0 text-gray-400" /> */}
                        {item.icon && (<item.icon
                          aria-hidden="true"
                          className={classNames(
                            item.current ? 'text-white' : 'text-gray-200 group-hover:text-white',
                            'size-6 shrink-0',
                          )}
                        />)}
                        {item.img && (<img
                          alt=""
                          src={item.img}
                          className={classNames(
                            item.current ? 'text-white' : 'text-gray-200 group-hover:text-white',
                            'size-6 shrink-0',
                          )}
                        />)}
                        <span className="truncate">{t(item.label)}</span>
                        <ChevronRightIcon
                          aria-hidden="true"
                          className="ml-auto size-5 shrink-0 text-gray-200 group-data-[open]:rotate-90 group-data-[open]:text-white"
                        />
                      </DisclosureButton>
                      <DisclosurePanel as="ul" className="mt-1 px-2">
                        {item.subMenu.map((subItem) => (
                          <li key={subItem.label}>
                            <DisclosureButton
                              as="button"
                              onClick={() => { mainMenuClick(subItem) }}
                              className={classNames(
                                subItem.current ? 'bg-light-primary text-white'
                                  : 'text-gray-200 hover:bg-light-primary hover:text-white',
                                'group flex w-full items-center gap-x-3 rounded-xl py-2 pl-5 pr-2 text-left text-sm/8',
                              )}
                            >
                              {subItem.icon && (<subItem.icon
                                aria-hidden="true"
                                className={classNames(
                                  subItem.current ? 'text-white' : 'text-gray-200 group-hover:text-white',
                                  'size-5 shrink-0',
                                )}
                              />)}
                              {subItem.img && (<img
                                alt=""
                                src={subItem.img}
                                className={classNames(
                                  subItem.current ? 'text-white' : 'text-gray-200 group-hover:text-white',
                                  'size-5 shrink-0',
                                )}
                              />)}
                              {subItem.label}
                            </DisclosureButton>
                          </li>
                        ))}
                      </DisclosurePanel>
                    </Disclosure>
                  )}
                </li>
              ))}
            </ul>
          </li>
          {settingMenuList.length > 0 && (<li>
            <div className="text-xs/6 font-semibold text-gray-200">Settings</div>
            <ul className="-mx-2 mt-2 space-y-1">
              {settingMenuList.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => { settingMenuClick(item) }}
                    className={classNames(
                      item.current
                        ? 'bg-light-primary text-white'
                        : 'text-gray-200 hover:bg-light-primary hover:text-white',
                      'group w-full flex gap-x-3 rounded-xl p-2 text-lg font-semibold',
                    )}
                  >
                    <item.icon
                      aria-hidden="true"
                      className={classNames(
                        item.current ? 'text-white' : 'text-gray-200 group-hover:text-white',
                        'size-6 shrink-0',
                      )}
                    />
                    <span className="truncate">{t(item.label)}</span>
                  </button>
                </li>
              ))}
            </ul>
          </li>)}
          <li className="mt-auto flex justify-center border-t border-box-border"></li>
          <li className="flex justify-center">
            <button
              type="button"
              onClick={() => {
                if (typeof onAIAssistantToggle === 'function') {
                  onAIAssistantToggle();
                }
              }}
              className="group -mx-2 flex gap-x-3 justify-start items-center rounded-xl p-2 text-lg font-semibold text-white bg-primary hover:bg-light-primary w-full"
            >
              <SparklesIcon
                aria-hidden="true"
                className="size-6 shrink-0 text-white"
              />
              <span className="truncate">{t("pageTitle.aiAssistant")}</span>
              <span className="ml-auto text-[10px] font-bold bg-white/20 text-white px-1.5 py-0.5 rounded-md uppercase tracking-wide">Beta</span>
            </button>
          </li>
          <li className="flex justify-center">
            <button
              type="button"
              onClick={onContactClick}
              className="group -mx-2 flex gap-x-3 justify-start items-center rounded-xl p-2 text-lg font-semibold text-secondary hover:text-white hover:bg-secondary w-full"
            >
              <WhatsAppIcon />
              <span className="truncate">{t("pageTitle.getSupport")}</span>
            </button>
          </li>
          <li className="flex justify-center mb-3">
            <button
              onClick={() => {
                logout();
              }}
              className={classNames(
                'text-secondary hover:bg-secondary hover:text-white',
                'group w-full flex gap-x-3 rounded-xl p-2 text-lg font-semibold',
              )}
            >
              <LogoutIcon
                aria-hidden="true"
                className={classNames(
                  'text-secondary group-hover:text-white',
                  'size-6 shrink-0',
                )}
              />
              <span className="truncate">{t("pageTitle.logout")}</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
